(function(angular) {
    'use strict';
    window.THF.Angular.JoinForm.factory('thfFieldDefinitionConfirm', function() {
        return {
            'declareRebate': {
                'label': '',
                'labelStyle': '',
                'name': 'declareRebate',
                'defaultValue': '',
                'placeholder': '',
                'tooltip': '',
                'disabled': true,
                'options': [
                    {'label': 'I declare that the information provided in this <a href="#" ng-click="fieldActions.openRebateForm($event)">Australian Government Private Health Insurance Rebate form</a> is complete and correct and I understand that giving false or misleading information is a serious offence.', 'value': 'Y'}
                ],
                'validation': [
                    'required'
                ]
            },
            'declareRebateError': {
                'label': '',
                'labelStyle': '',
                'name': 'declareRebateError',
                'defaultValue': 'false',
                'placeholder': '',
                'tooltip': '',
                'options': [],
                'validation': []
            },
            'declareInfo': {
                'label': '',
                'labelStyle': '',
                'name': 'declareInfo',
                'defaultValue': '',
                'placeholder': '',
                'tooltip': '',
                'options': [
                    {
                        'label': 'I declare that the information provided in this form is true and correct. ' +
                        'I have read the <a href="/privacy-notice/" target="_blank">Privacy Notice</a> and agree to the collection and use of my personal and sensitive information as outlined therein. ' +
                        `I agree to be bound by the <a href="${ 
                            joinFormPageData.siteName === 'Teachers Health' ? 'https://cdn.tfhwebassets.com.au/assets/thf/publications/fund-rules.pdf' : 
                            joinFormPageData.siteName === 'Nurses & Midwives Health' ? 'https://cdn.tfhwebassets.com.au/assets/nmh/publications/fund-rules.pdf' :
                            joinFormPageData.siteName === 'UniHealth' ? 'https://cdn.tfhwebassets.com.au/assets/uhi/publications/fund-rules.pdf' :
                            'https://cdn.tfhwebassets.com.au/assets/thf/publications/fund-rules.pdf'
                        }" target="_blank">` + joinFormPageData.siteName + ` Rules</a> as amended from time to time and understand that with notice my contribution rates may increase and/or my benefit entitlements may change. ` +
                        'I understand that waiting periods may apply to my chosen level of cover (including 12 months for pre-existing conditions).', 'value': 'Y',
                    }
                ],
                'validation': [
                    'required'
                ]
            },

            'marketing': {
                'label': '',
                'labelStyle': '',
                'name': 'marketing',
                'defaultValue': '',
                'placeholder': '',
                'tooltip': '',
                'options': [
                    {
                        'label': 'Yes, I\'d like to receive free health updates, special offers and other related information from ' + joinFormPageData.siteName + '.', 'value': 'Y'
                    }
                ],
                'validation': [
                ]
            },
            'communication': {
                'label': '',
                'labelStyle': '',
                'name': 'communication',
                'defaultValue': '',
                'placeholder': '',
                'tooltip': '',
                'options': [
                    {
                        'label': 'I authorise communication from ' + joinFormPageData.siteName + ', including information required by law such as tax statements, via email to the address supplied.', 'value': 'Y'
                    }
                ],
                'validation': [
                ]
            },

            'howDidYouHear': {
                'label': 'How did you hear about ' + joinFormPageData.siteName + '?',
                'labelStyle': '',
                'name': 'howDidYouHear',
                'defaultValue': '',
                'placeholder': '',
                'tooltip': '',
                'options': joinFormPageData.hdyhAboutUs,
                    /*[
                    {label: 'Advertising',                      value: 'advertising'},
                    {label: 'Members Own Health Funds',         value: 'Members Own Health Funds'},
                    {label: 'Online search',                    value: 'online'},
                    {label: 'Social media',                     value: 'Social Media'},
                    {label: 'Sales rep at school/conference',   value: 'sales_rep'},
                    {label: 'Word of mouth (family)',           value: 'word_of_mouth_family'},
                    {label: 'Word of mouth (colleague)',        value: 'word_of_mouth_colleague'},
                    {label: 'Transfer from existing policy',    value: 'transfer existing policy'},
                    {label: 'Previous member re-joining',       value: 'previous member re-joining'},
                    {label: 'From my union',                    value: 'from my union'},
                    {label: 'Other (please specify)',           value: 'other'}
                ],*/
                'validation': [
                    'required'
                ]
            },
            'howDidYouHearSpecify': {
                'label': 'Please Specify',
                'labelStyle': '',
                'name': 'howDidYouHearSpecify',
                'defaultValue': '',
                'placeholder': '',
                'tooltip': '',
                'validation': []
            },

            'promoCode': {
                'label': 'Promotional Code (if relevant)',
                'labelStyle': '',
                'name': 'promoCode',
                'defaultValue': '',
                'placeholder': '',
                'maxLength': 60,
                'tooltip': '',
                'validation': [],
                'validationMessage': 'Oops! Seems like you have the wrong promo code'
            },
            'referralMemberNumber': {
                'label': 'If you were referred by an existing ' + joinFormPageData.siteName + ' member, please enter their membership number below:',
                'labelStyle': '',
                'name': 'referralMemberNumber',
                'defaultValue': '',
                'placeholder': '',
                'tooltip': '',
                'validation': []
            }
        };
    });
})(angular);
